import { styled } from '@mui/system';
import { Box, Card, Typography, Button } from '@mui/material';
import { colors, fontFamilies } from '../../../constants/theme';

export const LoadingContainer = styled(Box)({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const NotFoundContainer = styled(Box)({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 32,
  textAlign: 'center',
  color: colors.primary,
});

export const NotFoundButton = styled(Button)({
  color: colors.whiteText,
  fontFamily: fontFamilies.quicksand,
  fontSize: 16,
  fontWeight: 600,
  padding: '12px 30px',
  textTransform: 'none',
  borderRadius: 4,
});

export const ContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 1200,
  width: '100%',
  margin: '0 auto',
  padding: '0 24px',
  [theme.breakpoints.down('md')]: {
    padding: '0 16px',
  },
}));

export const SectionContainer = styled(Box)(({ theme }) => ({
  padding: '40px 40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    padding: '30px 20px',
  },
}));

export const HeroSectionWrapper = styled(Box)(({ theme }) => ({
  color: colors.primary,
  padding: '40px 20px 60px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    padding: '30px 20px 40px',
  },
}));

export const InfoCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  padding: 32,
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const SectionTitle = styled(Typography)({
  fontFamily: fontFamilies.gotham,
  fontSize: 20,
  fontWeight: 600,
  color: colors.primary,
  marginBottom: 16,
});

export const SectionHeading = styled(Typography)(({ theme }) => ({
  ...theme.typography.heading,
  textAlign: 'center',
}));

export const SectionSubtext = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  textAlign: 'center',
}));

export const ContentText = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontSize: 18,
  lineHeight: 1.8,
  color: colors.textLight,
  whiteSpace: 'pre-line',
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
  },
}));

export const ListItemWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 16,
  padding: '4px 0',
});

export const ListItemBullet = styled(Box)({
  width: 6,
  height: 6,
  borderRadius: '50%',
  marginTop: 8,
  flexShrink: 0,
});

export const ListItemText = styled(Typography)({
  fontFamily: fontFamilies.quicksand,
  fontSize: 15,
  fontWeight: 400,
  color: '#2c2c2c',
  lineHeight: 1.4,
  flex: 1,
});

export const ContactItemText = styled(Typography)({
  fontFamily: fontFamilies.quicksand,
  fontSize: 16,
  fontWeight: 400,
  color: '#2c2c2c',
  lineHeight: 1.5,
});

export const NoDataText = styled(Typography)({
  textAlign: 'center',
  color: colors.textLight,
  fontFamily: fontFamilies.quicksand,
  fontSize: 16,
  marginTop: 32,
});

export const CredentialsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 24,
  alignItems: 'stretch',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const CredentialCard = styled(InfoCard)({
  minHeight: 280,
});

export const LanguagesCard = styled(InfoCard)(({ theme }) => ({
  minHeight: 140,
  gridColumn: '1 / -1',
  [theme.breakpoints.down('md')]: {
    gridColumn: '1',
  },
}));
